
const $el = $(el);
const $hero         = document.querySelector('[data-component="sections/hero"]');
const $btnContact   = el.querySelector('.btn-contact');
const $closeButton  = el.querySelectorAll('[data-close]');
const $btnNextStep  = el.querySelectorAll('[data-next]');
const $sliderTrack  = el.querySelector('.slider-track');
const $sliderSteps  = el.querySelector('.slider-steps');
const $radioButtons = el.querySelectorAll('.box-input input[type="radio"]');
const $textInputs   = el.querySelectorAll('.box-input input[type="text"]');

const $form = $el.find('#formContact');

const isPt = document.documentElement.lang == 'pt';

var maskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
}, options = {
    onKeyPress: function(val, e, field, options) {
            field.mask(maskBehavior.apply({}, arguments), options);
        }
    };

if(isPt) {
    $el.find('#telefone').mask(maskBehavior, options);
}

const screenSize = $hero.offsetHeight;
let trackIndex = 0;

window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > screenSize) {
        el.setAttribute('data-button-show', true);
    } else {
        el.removeAttribute('data-button-show');
    }
});

window.dispatchEvent(new CustomEvent('scroll'));

$btnContact.addEventListener('click', function () {
    $sliderSteps.classList.add('active');
    $btnContact.classList.add('hide');
});

const next = () => {
    trackIndex++;

    $sliderTrack.style.left = `-${trackIndex * 100}%`;
};

const close = () => {
    $sliderSteps.classList.remove('active');
    $btnContact.classList.remove('hide');
    $sliderTrack.style.left = `0`;

    $radioButtons.forEach(function($radioButton) {
        removeError($radioButton);
    });

    trackIndex = 0;
};

const removeError = ($el) => {
    $el.parentElement.classList.remove('error');
};

const addError = ($el) => {
    $el.parentElement.classList.add('error');
};

$btnNextStep.forEach(function(btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();

        if(btn.dataset.next == 'first') {
            let checked = false;
            $radioButtons.forEach(function ($radio) {
                if($radio.checked) {
                    checked = true;
                }
            });

            if(checked) {
                next();
            } else {
                $radioButtons.forEach(function($radioButton) {
                    addError($radioButton);
                });
            }
        } else {
            btn.classList.add('sending');
            btn.disabled = true;

            let error = false;

            $textInputs.forEach(function ($input) {
                if($input.value === '') {
                    error = true;
                    addError($input);
                } else {
                    if($input.id === 'email') {
                        // verify email
                        const email = $input.value;
                        const regex = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;

                        if(!regex.test(email)) {
                            error = true;
                            addError($input);
                        } else {
                            removeError($input);
                        }
                    } else if($input.id === 'telefone') {
                        if(isPt) {
                            // verify phone number
                            const phone = $input.value;
                            const regex = /^\(\d{2}\) \d{4,5}-?\d{4}$/;

                            if(!regex.test(phone)) {
                                error = true;
                                addError($input);
                            } else {
                                removeError($input);
                            }
                        } else {
                            removeError($input);
                        }
                    } else {
                        removeError($input);
                    }
                }
            });

            if(!error) {
                const data = $form.serialize();

                $.post(`${base}api/contatos`, data, function(response) {
                    if(!response.error) {
                        btn.classList.remove('sending');
                        btn.disabled = false;
                        $form[0].reset();

                        next();
                    }
                }, 'json').fail(function(response) {
                });
            }
        }
    });
});

$closeButton.forEach(function(btn) {
    btn.addEventListener("click", function () {
        close();
    });
});

$radioButtons.forEach(function name(radio) {
    radio.addEventListener("click", function () {
        next();
    });
});

$body.on('click', function (e) {
    if ($(e.target).closest(el).length === 0) {
        close();
    }
});